import React, { useContext, useState } from "react";
import {
  Toolbar,
  Box,
  // List,
  // ListItem,
  // ListItemButton,
  // ListItemText,
  // Tooltip,
  ListItemIcon,
  CssBaseline,
  Avatar,
  Theme,
  CSSObject,
  styled,
  IconButton,
  Menu,
  MenuItem,
  Divider,
  Button,
} from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import { useNavigate, Outlet } from "react-router-dom";
// import MenuIcon from "@mui/icons-material/Menu";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import { UserContext } from "../contexts/userContext";

const drawerWidth = 220;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  variants: [
    {
      props: ({ open }) => open,
      style: {
        ...openedMixin(theme),
        "& .MuiDrawer-paper": openedMixin(theme),
      },
    },
    {
      props: ({ open }) => !open,
      style: {
        ...closedMixin(theme),
        "& .MuiDrawer-paper": closedMixin(theme),
      },
    },
  ],
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  variants: [
    {
      props: ({ open }) => open,
      style: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}));

const Layout = () => {
  const { userData, handleSignOut } = useContext(UserContext);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);

  const handleClickMenu = (event: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(event.currentTarget);

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  // const handleDrawerOpen = () => {
  //   setOpen(true);
  // };

  // const handleDrawerClose = () => {
  //   setOpen(false);
  // };
  const navItems = [
    { text: "Inicio", path: "/", icon: "home" },
    { text: "Productos", path: "/stock", icon: "inventory_2" },
    { text: "Ingredientes", path: "/ingredients", icon: "grocery" },
    { text: "Promociones", path: "/promotions", icon: "percent_discount" },
    { text: "Categorias", path: "/categories", icon: "category" },
    { text: "Medios de pagos", path: "/payment-methods", icon: "credit_card" },
    {
      text: "Historial de ventas",
      path: "/sell-list",
      icon: "receipt_long",
    },
    // {
    //   text: "Estadisticas",
    //   path: "/sell-list",
    //   icon: "analytics",
    // },
    {
      text: "Menu",
      path: "/menu",
      icon: "menu_book_2",
    },
  ];
  const navigate = useNavigate();

  const handleNavigate = (path: string) => navigate(path);

  const getInitials = (name: string) => {
    if (!name) return "";
    return name.split(" ")[0][0].toUpperCase();
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <Toolbar>
          {/* <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => (open ? handleDrawerClose() : handleDrawerOpen())}
            edge="start"
            sx={[
              {
                marginRight: 5,
              },
            ]}
          >
            <MenuIcon />
          </IconButton> */}
          <Box
            component="a"
            sx={{ flexGrow: 1, my: 1 }}
            onClick={() => handleNavigate("/")}
          >
            {/* <img src={logo} className="w-logo" aria-label="logo" /> */}
          </Box>
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            {navItems.map((item) => (
              <Button
                variant="text"
                key={item.path}
                sx={{ color: "#fff" }}
                onClick={() => handleNavigate(item.path)}
              >
                {item.text}
              </Button>
            ))}
          </Box>
          <IconButton
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClickMenu}
          >
            <Avatar>{userData.name ? getInitials(userData.name) : ""}</Avatar>
          </IconButton>
        </Toolbar>
      </AppBar>
      {/* <Drawer variant="permanent" open={open}>
        <List sx={{ mt: 8 }}>
          {navItems.map(({ text, path, icon }) => (
            <ListItem key={text} disablePadding>
              <ListItemButton
                sx={[
                  {
                    minHeight: 48,
                    px: 2.5,
                  },
                  open
                    ? {
                        justifyContent: "initial",
                      }
                    : {
                        justifyContent: "center",
                      },
                ]}
                onClick={() => handleNavigate(path)}
              >
                {!open ? (
                  <Tooltip title={text} arrow placement="right">
                    <ListItemIcon
                      sx={[
                        {
                          minWidth: 0,
                          justifyContent: "center",
                        },
                        open
                          ? {
                              mr: 3,
                            }
                          : {
                              mr: "auto",
                            },
                      ]}
                    >
                      <span className="material-symbols-rounded">{icon}</span>
                    </ListItemIcon>
                  </Tooltip>
                ) : (
                  <ListItemIcon
                    sx={[
                      {
                        minWidth: 0,
                        justifyContent: "center",
                      },
                      open
                        ? {
                            mr: 3,
                          }
                        : {
                            mr: "auto",
                          },
                    ]}
                  >
                    <span className="material-symbols-rounded">{icon}</span>
                  </ListItemIcon>
                )}

                <ListItemText
                  primary={text}
                  sx={[
                    open
                      ? {
                          opacity: 1,
                        }
                      : {
                          opacity: 0,
                        },
                  ]}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer> */}
      <Outlet />
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
        slotProps={{
          list: {
            "aria-labelledby": "basic-button",
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box p={2}>
          <Box sx={{ display: { md: "none" } }}>
            {navItems.map((item) => (
              <MenuItem
                key={item.path}
                onClick={() => handleNavigate(item.path)}
              >
                <ListItemIcon>
                  <span className="material-symbols-rounded">{item.icon}</span>
                </ListItemIcon>
                {item.text}
              </MenuItem>
            ))}
          </Box>
          <MenuItem
            onClick={() => {
              handleNavigate("profile");
              handleCloseMenu();
            }}
          >
            <ListItemIcon>
              <span className="material-symbols-rounded">person</span>
            </ListItemIcon>
            Perfil
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleSignOut}>
            <ListItemIcon>
              <span className="material-symbols-rounded">logout</span>
            </ListItemIcon>
            Cerrar sesión
          </MenuItem>
        </Box>
      </Menu>
    </Box>
  );
};

export default Layout;
